import React, { useEffect, useState, useCallback } from 'react'

import * as MillConfigAPI from '../dashboard/MillConfigAPI'
import * as UserAPI from '../login/UserAPI'

import * as Environment from '../environment'
import { getNotifications, getNotificationsConfig } from '../news/NewsAPI'

export const MillContext = React.createContext({
    millUser: {},
    millConfig: {},
    mill: {},
    loadMill: () => {},
    isUseTributes: () => false,
    showErrorModal: () => {},
    isModalVisible: false,
    modalMessage: '',
})

export const useMillContext = () => React.useContext(MillContext)

export const MillContextProvider = ({ children }) => {
    const [millUser, setMillUser] = useState()
    const [mill, setMill] = useState()
    const [millConfig, setMillConfig] = useState()
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [modalMessage, setModalMessage] = useState('')
    const [isModalNewsNotificationVisible, setIsModalNewsNotificationVisible] =
        useState(false)

    const loadMill = useCallback(async userId => {
        await loadMillUserInfo(userId)
        await loadMillConfig()
        await loadNotifications()
    }, [])

    useEffect(() => {
        const userToken = Environment.getToken({ withPayload: true })
        if (!millUser && userToken) {
            loadMill(userToken.accessToken.payload.id)
        }
    }, [millUser, loadMill])

    const loadMillConfig = async () => {
        const response = await MillConfigAPI.getMillConfig()

        if (response && response.data) {
            setMillConfig(response.data)
            return
        }

        return
    }

    const loadMillUserInfo = async userId => {
        const response = await UserAPI.getUser(userId)

        if (response && response.user) {
            setMillUser({
                user: response.user,
                aclUserGroups: response.aclUserGroups,
            })
            setMill(response.user.mill)
        }

        return
    }

    const loadNotifications = async () => {
        try {
            const [notificationsFetch, notificationsConfigFetch] =
                await Promise.all([
                    getNotifications(),
                    getNotificationsConfig(),
                ])

            const notifications = notificationsFetch?.data || []
            const notificationsConfig = notificationsConfigFetch?.data || {}

            const hasUnreadNotifications = notifications.some(notification => {
                return !notificationsConfig?.viewedNotifications?.includes(
                    notification.id
                )
            })

            if (hasUnreadNotifications) {
                setIsModalNewsNotificationVisible(true)
            }
        } catch (error) {
            console.error('Error loading notifications:', error)
        }
    }

    const isUseTributes = () => {
        return Boolean(millConfig?.useTributes)
    }

    const showErrorModal = message => {
        setModalMessage(message)
        setIsModalVisible(true)
    }

    const closeModal = () => {
        setIsModalVisible(false)
        setModalMessage('')
    }

    return (
        <MillContext.Provider
            value={{
                mill,
                millConfig,
                millUser,
                loadMill,
                isUseTributes,
                showErrorModal,
                isModalVisible,
                modalMessage,
                closeModal,
                isModalNewsNotificationVisible,
                setIsModalNewsNotificationVisible,
            }}
        >
            {children}
        </MillContext.Provider>
    )
}
